import React from 'react'
import { Stack } from '@sureco/design-system'
import EducationConfiguration from './components/EducationConfiguration'

export default function EducationTab({ id }: { id: string }) {
  return (
    <Stack space={20}>
      <EducationConfiguration id={id} />
    </Stack>
  )
}
